import React from 'react';
import styled from 'styled-components';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { Space } from 'styles/themeSpaces';
import { Text } from 'styles/themeColors';
import { CREDIT_MESSAGES } from 'constants/credit';

const ModalContent = styled.div`
  color: ${Text.primary};
  font-size: 16px;
  line-height: 20px;
`;

const Warning = styled.div`
  color: ${Text.secondary};
  font-size: 14px;
  line-height: 18px;
  font-style: italic;
  margin-top: ${Space.spBase};
`;


const SwitchToOFMPModal = () => {
  return (
    <FlexboxContainer flexDirection="column">
      <ModalContent>
        {CREDIT_MESSAGES.SWITCH_TO_OFMP_CONFIRMATION} 
      </ModalContent>
    </FlexboxContainer>
  );
};

export default SwitchToOFMPModal;